import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FeatureFlagEnum, FeatureFlagsState } from '../models/feature-flag.model';
import { FeatureFlagStoreService } from './feature-flag.store';

@Injectable({ providedIn: 'root' })
export class FeatureFlagFacade {
  #featureFlagStore = inject(FeatureFlagStoreService);

  isSpendTypeEnabled$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.SpendType);

  googleLocationSearchEnabled$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.GoogleLocationSearch);
  replaySessionEnabled$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.ReplaySession);
  displayCidEnabled$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.DisplayCid);
  disableIntercomEnabled$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.DisableIntercom);
  showAdditionalPropertyTypesEnabled$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.ShowAdditionalPropertyTypes);
  showCPLGroupBookingEnabled$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.ShowCPLGroupBooking);
  showCPLMeetingVenueEnabled$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.ShowCPLMeetingVenue);
  useBookingsModuleFromMonorepoLibraryEnabled$ = this.#featureFlagStore.getFlagByName$(
    FeatureFlagEnum.UseBookingsModuleFromMonorepoLibrary,
  );
  useClientsiteAuthAppEnabled$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.UseClientsiteAuthApp);
  roomexPayPortalEnabled$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.RoomexPayPortal);
  roomexPayReports$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.RoomexPayReports);
  roomexPayVat$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.EnableRoomexPayVat);
  showTrainlineTicketsButtonEnabled$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.ShowTrainlineTicketsButton);
  saverplusSameDayRateEnabled$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.SaverplusSameDayRate);
  overrideUSRegionalSettings$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.OverrideUSRegionalSettings);
  useReportV2TrainlineEnabled$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.UseReportV2Trainline);
  trainlineShowAllReports$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.TrainlineShowAllReports);
  useSummaryReservationDetailsComponent$ = this.#featureFlagStore.getFlagByName$(
    FeatureFlagEnum.UseSummaryReservationDetailsComponent,
  );
  minimumNumberOfFoundLocations$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.MinimumNumberOfFoundLocations);
  navigateToRoomDetailsInNewTab$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.NavigateToRoomDetailsInNewTab);
  useDefaultLocale$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.UseDefaultLocale);
  showLoyaltyGuaranteed$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.ShowLoyaltyGuaranteed);
  showCO2Emissions$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.ShowCO2Emissions);
  showTruckParkingFilter$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.ShowTruckParkingFilter);
  recentSearchesPillsEnabled$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.recentSearchesPillsEnabled);
  mergeHotelDetailsRoomSelectPage$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.MergeHotelDetails_RoomSelectPage);
  selfUserManagementEnabled$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.SelfUserManagement);
  locationSearchSplitMapView$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.LocationSearchSplitMapView);
  enableMapViewBoundedSearch$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.EnableMapViewBoundedSearch);
  temporaryApprover$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.TemporaryApprover);
  useBrandConfigValue$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.UseBrandConfigValue);
  enableSelfCustomFieldEnabled$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.EnableSelfCustomField);
  enableSecondHotelSearchStandardRoom$ = this.#featureFlagStore.getFlagByName$(
    FeatureFlagEnum.EnableSecondHotelSearchStandardRoom,
  );
  enableInviteUsers$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.EnableInviteUsers);

  // Experiments
  experimentStay917$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.Experiment_Stay_917);
  experimentStay924$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.Experiment_Stay_924);
  longStayModalRedirect$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.Long_Stay_Redirect_Modal);
  pocNoRoomsWorkflow$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.Poc_enable_no_rooms_workflow);
  enableOccupancySearch$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.Enable_occupancy_search);

  datepickerTabs$ = this.#featureFlagStore.getFlagByName$(FeatureFlagEnum.DatepickerTabs);

  isFeatureFlagEnabled$(featureFlag: FeatureFlagEnum): Observable<boolean> {
    return this.#featureFlagStore.getFlagByName$(featureFlag);
  }

  setFlags(flags: FeatureFlagsState): void {
    this.#featureFlagStore.setFlags(flags);
  }
}
